import React, { Component } from "react";
import {
  Icon,
  Modal,
  Select,
  Radio,
  Row,
  Col,
  Spin,
  Input,
  message,
  Button,
  notification,
  Checkbox,
  Tooltip
} from "antd";
import axios from "axios";
import moment from "moment-timezone";
import { Translate } from "react-translated";
import DatePicker from "react-datepicker";
import F from "../../../Functions";
import { extendWith, reject } from "lodash";
import { AGENT, FOLLOWUP, FOLLOW_UP_SPECIALIST_APPOINTMENT, PROSPECT, SUB_TYPE_OF_CALL, TYPE, TYPE_OF_CALL_FOLLOW_UP, TYPE_OF_CALL_PROSPECT, get_label_from_value, type_of_call_format } from "../../../utils/Constants";
import Microsoft_apppointment from "./microsoft_apppointment";
import { withRouter } from "react-router-dom";
import { CREATE_CALL_ATTEMPT_HISTORY, SCHEDULE_APPOINTMENT } from "../../../utils/Api_enums";
import { useBoundStore } from "../../../store/useBoundStore";

const { TextArea } = Input;
const Option = Select.Option;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
  state = {
    loading: true,
    bfile: this.props.bfile,
    user: this.props.user,
    timezone: this.props.bfile.timezone,
    users: [],
    lsp: "",
    customer_info: null,
    action: "1",
    type: "",
    type_of_call: this.props.bfile.type_of_call || "FollowUp",
    sub_type_of_call: this.props.bfile.type_of_call && get_label_from_value(this.props.bfile.sub_type_of_call, 'value', this.props.bfile.type_of_call || 'FollowUp') ? Array.from(new Set((type_of_call_format(this.props.bfile.type_of_call) === 'followup' ? "Thank You / Referrals," + get_label_from_value(this.props.bfile.sub_type_of_call, 'value', this.props.bfile.type_of_call || 'FollowUp') : get_label_from_value(this.props.bfile.sub_type_of_call, 'value', this.props.bfile.type_of_call || 'FollowUp') || "").split(","))).join(",") : type_of_call_format(this.props.bfile.type_of_call) === 'followup' ? 'Thank You / Referrals' : "",
    scheduled_via: "", // make default selected value to Internal System as suggested by Shweta
    // scheduled_via: "Internal System", // make default selected value to Internal System as suggested by Shweta
    isReferrals: false,
    referrals: [],
    appointment_date: moment(new Date()).add(15, "days"),
    microsoft_appointment_date: moment(),
    calendly_rs_setup_appointment_date: moment(new Date()).add(15, "days"),
    appointment_date_time: "",
    appointment_day: null,
    invitee_email:
      this.props.bfile.email && this.props.bfile.email !== ""
        ? this.props.bfile.email
        : "",
    note: "",
    appointment_hours: null,
    calendar_invites: [],
    virtual_link: null,
    has_calendly: false,
    meeting_link: null,
    has_manual_links: false,
    has_microsoft: false,
    calendly_loading: false,
    microsoft_loading: false,
    calendly_link: null,
    customer_email: "",

    // new add
    agentScheduledAppointmentWithCalendly: {}, // { "lsp_id": false, "lsp_id": false},
    externalLinks: [],
    type_of_call_old: this.props.bfile.type_of_call || "FollowUp",
    roles: JSON.parse(localStorage.getItem('roles')),
    onboarder_id: useBoundStore.getState().userInfo.id,
    onboarding_id: useBoundStore.getState().userInfo.id,
  };


  microsoft_ref = React.createRef(null);

  range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }
  disabledDate = (current) => {
    return current && current < moment().add(-1, "days");
  };
  disabledDateTime = () => {
    return {
      disabledHours: () => this.range(0, 6)
      //disabledMinutes: () => this.range(30, 60)
    };
  };
  componentDidMount = () => {
    let bfile = this.state.bfile;  // NOSONAR
    console.log(this.state.onboarder_id)
    F.log("User = > ", this.props.user);
    if (!bfile.email || (bfile.email && bfile.email === "")) {
      bfile.email = "noemail@bfilesystem.com";
    }
    this.getAssociations();
    this.setState({
      lsp: this.state.bfile.user.id,  // NOSONAR
      customer_info: bfile,
      appointment_hours: this.state.bfile.user.appointment_hours // NOSONAR
        ? JSON.parse(this.state.bfile.user.appointment_hours) // NOSONAR
        : null,
      timezone: this.state.bfile.timezone, // NOSONAR
      virtual_link: this.state.bfile.user.virtual_link, // NOSONAR
      has_calendly: this.state.bfile.user.calendly_access_token ? true : false, // NOSONAR
      has_microsoft: this.state.bfile.user.microsoft_access_token ? true : false, // NOSONAR
      has_manual_links: this.state.bfile.user.manual_microsoft_enable ? true : false, // NOSONAR
      scheduled_via: "",
      note: this.state.bfile.user.virtual_link // NOSONAR
        ? this.state.bfile.user.virtual_link // NOSONAR
        : ""
    }, () => {
      this.loadingSchedulingData(this.state.type_of_call) // NOSONAR
    });
  };

  reloadData = () => {
    // if (this.props.refresh) {
    //   F.log("Has Refresh")
    // } else {
    //   F.log("Doesn't have Refresh");
    // }
    if (this.props.refresh) {
      this.props.refresh();
    } else {
      // this.props.history.push("/dashboard");
      // this.props.history.replace(this.state.user.id !== 2 ? "/dashboard" : "/bfiles");
      this.props.history.goBack();
    }
  };


  loadingSchedulingData = async (type_of_call) => {
    // console.log("userid chjeck", userId);
    const userId = this.state.lsp;
    try {
      // this.setState({ loading: true });
      const { data } = await axios.get(`/api/meeting/links/specialist/review/bulk/fetch`, {
        params: {
          user_id: userId,
          interested_call_types: type_of_call.toLowerCase(),
        },
      });

      if (data && data.success) {
        //  return data;
        this.setState({
          //  schedule_meetings: data.meetings_list,
          // externalLinks:data.meetings_details.type_of_call.toLowerCase()
          externalLinks: data.meetings_details[`${type_of_call.toLowerCase()}`]
        });
      }


    } catch (error) {
      console.log(error);
    } finally {
      // this.setState({ loading: false });
    }
  };
  getAssociations = () => {
    const { bfile } = this.state;

    axios
      .get("/api/agency_associations_appointments/" + bfile.agency_id)
      .then(async (res) => {
        let users = [];
        let externalLinks = [];
        let calendar_invites = [];
        for (var i = 0; i < res.data.length; i++) {
          let user = res.data[i];

          if (user.id === this.state.lsp) {
            calendar_invites = user.calendar_invites;
          }

          if (user.user_type == "EA") {
            await axios.get("/api/users/" + user.id).then((res) => {
              users.push({
                name: user.first_name + " " + user.last_name,
                id: user.id,
                user_type: user.user_type,
                carrier: res.data.carrier,
                appointment_hours: user.appointment_hours,
                calendar_invites: user.calendar_invites,
                virtual_link: user.virtual_link,
                has_calendly: user.has_calendly,
                has_microsoft: user.has_microsoft,
                has_manual_links: user.has_manual_links,
                note: user.virtual_link ? user.virtual_link : ""
              });
            })
          }
          if (user.user_type == "LSP") {
            users.push({
              name: user.first_name + " " + user.last_name,
              id: user.id,
              user_type: user.user_type,
              appointment_hours: user.appointment_hours,
              calendar_invites: user.calendar_invites,
              virtual_link: user.virtual_link,
              has_calendly: user.has_calendly,
              has_manual_links: user.has_manual_links,
              has_microsoft: user.has_microsoft,
              note: user.virtual_link ? user.virtual_link : ""
            });
          }

          // const data =  await this.loadingSchedulingData(user.id);
          // externalLinks.push({meetings_list:data.meetings_list , userId:user.id});


        }

        this.setState({
          loading: false,
          users,
          calendar_invites,
          // externalLinks
        });
      });
  };
  componentDidUpdate = () => {
    if (this.props.bfile.id !== this.state.bfile.id) {
      let bfile = this.props.bfile;
      if (!bfile.email || (bfile.email && bfile.email === "")) {
        bfile.email = "noemail@bfilesystem.com";
      }
      this.setState(
        {
          bfile: this.props.bfile,
          note: "",
          action: "1",
          appointment_date: moment(new Date()).add(15, "days"),
          lsp: this.props.bfile.user.id,
          customer_info: bfile,
          timezone: this.props.bfile.timezone
        },
        () => {
          // this.getAssociations();
        }
      );
    }
  };

  saveCallAttemptHistory = async (bfile, action) => {
    try {
      await axios.post(CREATE_CALL_ATTEMPT_HISTORY, {
        bfile_id: bfile.id,
        scheduler_specialist_id: this.props.user.id,
        bfile_user_id: this.state.lsp,
        agency_id: bfile.agency_id,
        type_of_call: bfile.type_of_call,
        sub_type_of_call: bfile.sub_type_of_call,
        first_name: bfile.first_name,
        last_name: bfile.last_name,
        phone: bfile.phone,
        action: action
      });
    } catch (error) {
      console.error("Failed to save call attempt history:", error);
    }
  };

  // commented create manual links function 
  // createLink = async () => {
  //   const { bfile, user } = this.state;
  //   this.setState({
  //     calendly_loading: true
  //   });
  //   const r = await axios.get(
  //     "/api/calendly/create_event_link/" +
  //     this.state.lsp +
  //     "?event_type=von_setup_appointment"
  //   );
  //   if (r.data.success) {
  //     var w = window.open("about:blank", "_blank");
  //     if (this.state.type === "Phone") {
  //       w.location =
  //         r.data.link +
  //         "?name=" +
  //         encodeURIComponent(
  //           this.state.customer_info.first_name +
  //           " " +
  //           this.state.customer_info.last_name
  //         ) +
  //         "&email=" +
  //         encodeURIComponent(
  //           this.state.customer_info.email || this.state.customer_email
  //         ) +
  //         "&location=" +
  //         encodeURIComponent("+1" + this.state.customer_info.phone);
  //     } else {
  //       w.location =
  //         r.data.link +
  //         "?name=" +
  //         encodeURIComponent(
  //           this.state.customer_info.first_name +
  //           " " +
  //           this.state.customer_info.last_name
  //         ) +
  //         "&email=" +
  //         encodeURIComponent(
  //           this.state.customer_info.email || this.state.customer_email
  //         ) +
  //         "&location=" +
  //         this.state.type;
  //     }

  //     const newAgentScheduledAppointmentWithCalendly = {
  //       ...this.state.agentScheduledAppointmentWithCalendly
  //     };
  //     newAgentScheduledAppointmentWithCalendly[this.state.lsp] = true;
  //     this.setState({
  //       calendly_loading: false,

  //       // new add
  //       agentScheduledAppointmentWithCalendly: newAgentScheduledAppointmentWithCalendly
  //     });
  //     // this.props.history.push("/dashboard");
  //   } else {
  //     this.setState({
  //       calendly_loading: false
  //     });
  //     // reset notification
  //     message.destroy();
  //     message.error("Agency Owner Has Not Selected The Event Type.");
  //     // message.error(r.data.error);
  //   }
  // };

  // createManualLink = () => {
  //   this.setState({
  //     loading: true,
  //     scheduled_via: 'Manual Microsoft Booking'
  //   });
  //   axios.get("/api/msbooking/manual_entry/display_link/" + this.state.lsp + "?service_type=von_setup_appointment")
  //     .then(res => {
  //       let meeting_link = null
  //       if (res.data && !res.data.success) {
  //         message.error(res.data.error_response)
  //       } else {
  //         meeting_link = res.data && res.data.meeting_link ? res.data.meeting_link : null
  //         this.setState({
  //           loading: false,
  //           meeting_link
  //         })
  //       }
  //     }).catch(err => {
  //       this.setState({
  //         loading: false
  //       });
  //       message.error("Internal server error. Please try after some time")
  //     })
  // }

  updateBFileDataForScheduleFollowUp = (appointment_date_arr) => {
    const { bfile, lsp, user, users, note, has_calendly, scheduled_via, referrals, invitee_email, type_of_call, type_of_call_old } = this.state;

    const notes_payload = {
      bfile_id: bfile.id,
      note: note,
      user_id: user.id,
      is_setup_appointment_note: true,
      type_of_call: this.state.type_of_call,
      sub_type_of_call: this.state.sub_type_of_call,
      action: "Setup Appointment",
    };

    let error = [];
    let errorObj = { first_name: "First Name", last_name: "Last Name", phone: "Phone Number" };

    referrals.forEach((e) => {
      Object.keys(e).forEach((key) => {
        if (e[key].trim().length === 0 && errorObj[key]) {
          error.push(errorObj[key]);
        }
        if (key === 'email' && e[key].trim().length !== 0) {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(e[key].trim())) {
            error.push("Correct Email");
          }
        }
        if (key === 'phone' && e[key].trim().length !== 14 && e[key].trim().length > 0) {
          error.push("Correct digits Phone Number");
        }
      });
    });

    if (error.length > 0) {
      error.forEach((err) => message.error(`Please Enter ${err}`));
      return;
    }


    this.setState({ loading: true });

    const rs_scheduled_date = moment(new Date()).utc().format("YYYY-MM-DDTHH:mm:ss");
    const appointment_date_tz = moment.tz(appointment_date_arr, this.state.timezone);




    let note_text = "";
    const agent = users.find((u) => u.id === lsp);
    if (agent) {
      const formattedDate = moment(appointment_date_arr).format("MM/DD/YYYY hh:mmA");
      const timezoneAbbr = moment.tz(this.state.timezone).format("z");
      const appointmentText = `${formattedDate} ${timezoneAbbr}`;

      note_text = `${FOLLOW_UP_SPECIALIST_APPOINTMENT}: ${appointmentText} - ${AGENT}: ${agent.name}`;
      if (this.state.type) {
        note_text += ` - ${TYPE}: ${this.state.type}`;
      }
    }

    const bFileData = {
      financial_id: this.state.lsp,
      email: invitee_email || "",
      von_appointment_date: appointment_date_tz.utc(),
      vo_claim_date: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      rs_scheduled_date,
      user_id: this.state.lsp,
      agency_id: bfile.agency_id,
      type_of_call: this.state.type_of_call,
      sub_type_of_call: this.state.sub_type_of_call,
      ea_questions: {
        financial_conversion_specialist: this.state.lsp,
      },
      appointment_history: {
        appointment_date: moment(new Date()).add(15, "days"),
        location: this.state.type,
      },
      bfile_notes: {
        note: note,
        action: note_text,
        notes_type: F.getNotesType(),
      },
      customer_timezone: this.state.timezone,
      onboarder_id: this.state.onboarder_id,
      onboarding_id: this.state.onboarding_id
    };

    axios.put(SCHEDULE_APPOINTMENT + "/" + bfile.id, bFileData)
      .then(() => {
        notification.success({ message: "Appointment scheduled successfully" });

        let usr = users.find(e => e.user_type === 'EA') || {};

        if (this.state.isReferrals) {
          return axios.post(`/api/add_referral/${bfile.id}`, { referrals })
            .finally(() => {
              this.props.hideModal();
            });
        } else {
          this.props.hideModal();
        }

        setTimeout(() => {
          this.reloadData();
        }, 100);
      })
      .catch((err) => {
        message.error(err.message || "Something went wrong!");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };


  scheduleFollowUpAction = () => {
    const {
      bfile,
      lsp,
      customer_info,
      timezone,
      has_calendly,
      scheduled_via,
      type,
      note,
      referrals,
      agentScheduledAppointmentWithCalendly,
      type_of_call,
      sub_type_of_call
    } = this.state;

    const hasScheduledAppointmentWithCalendly =
      agentScheduledAppointmentWithCalendly[lsp];

    let microsoft_data = {}

    // if (scheduled_via === 'Microsoft Booking') {
    //   microsoft_data = this.microsoft_ref.current.getState();
    // }

    if (
      F.checkAllFieldsValidated(
        timezone,
        customer_info,
        scheduled_via,
        type,
        note,
        hasScheduledAppointmentWithCalendly,
        type_of_call,
        sub_type_of_call,
        microsoft_data
      )
    ) {
      this.updateBFileDataForScheduleFollowUp(this.state.appointment_date);
    }
    {
      // if (this.state.scheduled_via === 'Calendly') {
      //   this.setState({ loading: true });

      //   var customerData = {
      //     first_name: customer_info.first_name,
      //     last_name: customer_info.last_name,
      //     phone: customer_info.phone,
      //     email: customer_info.email,
      //     type_of_call: this.state.type_of_call,
      //     sub_type_of_call: this.state.sub_type_of_call,
      //     vonboard: ['followup', 'prospect'].includes(this.state.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
      //     review: ['followup', 'prospect'].includes(this.state.type_of_call.split('-').join().toLowerCase()) ? 0 : 1
      //   };

      //   if (lsp !== "" && lsp !== bfile.user_id) {
      //     customerData.user_id = lsp;
      //     bfile.user_id = lsp;
      //   }

      //   axios.put("/api/b_file/" + customer_info.id, customerData).then(() => {
      //     axios
      //       .get(
      //         "/api/calendly/get_event_date/" +
      //         lsp +
      //         "?email=" +
      //         encodeURIComponent(customer_info.email)
      //       )
      //       .then((cr) => {
      //         if (cr.data.success) {
      //           this.updateBFileDataForScheduleFollowUp(cr.data.date);
      //         } else {
      //           this.setState({ loading: false });
      //           // message.error(cr.data.error);
      //           // reset notification
      //           message.destroy();
      //           message.error("Agency Owner Has Not Selected The Event Type.");
      //         }
      //       });
      //   });
      //   // }
      // } else
      //  {
      // }
    }
  };

  notReachedAndNotInterestedAction = () => {
    const { action, note, bfile, user, referrals, type_of_call, sub_type_of_call } = this.state;

    if (note.trim().length === 0) {
      // reset notification
      message.destroy();
      message.error(F.translate(`Note is required.`));
    } else {
      // set default note's action to null for Scheduled Appointment - Case
      let note_action = null;

      let data = null;

      /* Not Reached - Case */
      if (action === "0") {
        // update note's action
        note_action = "Not Reached";

        data = {
          // attempts: parseInt(bfile.attempts, 10) + 1,
          attempts: parseInt(bfile.attempts, 10),
          vob_attempted: 1,
          onboarder_id: user.id,
          // new adding
          vob_archived: null,
          vob_completed: null
        };

        // get Call Attempts From B File Question Array
        // let call_attempts = F.getCallAttemptsFromBFileQuestionArray(1, bfile);

        axios.post("/api/ea_questions", {
          bfile_id: bfile.id,
          call_attempts: 1,
          was_invite_sent: false
        });
      }

      /* Not Interested - Case */
      if (action === "2") {
        // update note's action
        note_action = "Not Interested";

        data = {
          // sp_500: 0,
          // vip: 0,
          // attempts: 0,
          is_onboarded: 1,
          onboarder_id: user.id,
          expiration_date: bfile.expiration_date,
          archive: 0,
          vob_archived: 1,
          // new adding
          vob_attempted: null,
          vob_completed: null
        };
        axios.post("/api/ea_questions", {
          bfile_id: bfile.id,
          call_attempts: 1,
          was_invite_sent: false
        });
      }

      // Call Notes API
      axios.post("/api/bfile_notes", {
        bfile_id: bfile.id,
        note: note,
        user_id: user.id,
        action: note_action,
        type_of_call: this.state.type_of_call,
        sub_type_of_call: this.state.sub_type_of_call,
        /*
        Commenting below line because this is not using on "Welcome" B File action of not-reached (Sharon -> User-Profile -> "Welcome" Action)
        File path for reff: ./src/scenes/Onboarding/parts/step1.js
        */
        // is_setup_appointment_note: true,
      });

      // Added {action == 1} -> works for only "Schedule Follow Up"
      // if (action === "1" && lsp !== "" && lsp !== bfile.user_id) {
      //   data.user_id = lsp;
      //   bfile.user_id = lsp;
      // }

      if (data) {
        this.setState({ loading: true });
        axios.put("/api/b_file/" + bfile.id, {
          ...data, type_of_call: this.state.type_of_call, sub_type_of_call: this.state.sub_type_of_call,
          vonboard: ['followup', 'prospect'].includes(this.state.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
          review: ['followup', 'prospect'].includes(this.state.type_of_call.split('-').join().toLowerCase()) ? 0 : 1
        }).then(() => {
          this.setState({ loading: false });
          this.props.hideModal();
          // this.props.history.push("/bfiles/upcoming-calls");
          setTimeout(() => {
            this.reloadData();
          }, 100);
          /* Schedule Follow Up - Case */
          // if (action === "1") {
          //   const appointment_date_tz = moment.tz(
          //     appointment_date,
          //     this.state.timezone
          //   );
          //   F.log("DATE ==>> 1 ", appointment_date);
          //   F.log("DATE ==>> 2", appointment_date_tz);
          //   const send_invite_date = appointment_date_tz.toDate().toUTCString();
          //   F.log("Send Invite Date 1 ==>>", send_invite_date);
          //   this.setState({
          //     loading: true,
          //   });
          //   var invite_note = "";
          //   if (this.state.type !== "") {
          //     invite_note = "Type: " + this.state.type;
          //   }
          //   axios
          //     .post("/api/send_invite", {
          //       bfile_id: bfile.id,
          //       date_time: send_invite_date,
          //       location: "",
          //       type: "review-scheduler-appointment",
          //       appointment_type: this.state.type,
          //       user_id: bfile.user_id,
          //       timezone: this.state.timezone,
          //       notes: invite_note,
          //     })
          //     .then((res) => {
          //       if (invitee_email !== "") {
          //         axios
          //           .post("/api/send_invite", {
          //             bfile_id: bfile.id,
          //             date_time: send_invite_date,
          //             location: "",
          //             type: "invite-attendee",
          //             email: invitee_email,
          //             notes: invite_note,
          //             user_id: user.id,
          //           })
          //           .then(() => {
          //             this.setState({
          //               loading: false,
          //             });
          //             this.props.hideModal();
          //             this.props.history.push("/dashboard");
          //           })
          //           .catch(() => {
          //             this.setState({
          //               loading: false,
          //             });
          //             message.error("Can't make invitee appointment.");
          //           });
          //       } else {
          //         this.setState({
          //           loading: false,
          //         });
          //         this.props.hideModal();
          //         this.props.history.push("/dashboard");
          //       }
          //     })
          //     .catch(() => {
          //       this.setState({
          //         loading: false,
          //       });
          //       message.error("Can't make appointment.");
          //     });
          // } else {
          //   this.props.hideModal();
          //   this.props.history.push("/bfiles/upcoming-calls");
          // }
        });
      }
    }
  };

  updateField = (name, value) => {
    let { customer_info } = this.state;

    customer_info[name] = value;

    this.setState({
      customer_info
    });
  };

  saveEmail = () => {
    const { bfile, customer_email } = this.state;

    if (customer_email !== "") {
      this.setState({ loading: true });
      axios
        .put("/api/b_file/" + bfile.id, {
          email: customer_email
        })
        .then((r) => {
          this.setState({
            loading: false
          });
        });
    }
  };

  onChangeScheduledVia = (e) => {
    this.setState({ scheduled_via: e.target.value })
  }
  onChangeIsReferrals = (e) => {
    this.setState({ isReferrals: e.target.value })
    if (e.target.value) {
      this.setState({ referrals: [{ first_name: "", last_name: "", email: "", phone: "" }] })
    } else {
      this.setState({ referrals: [] })
    }
  }

  addMoreReferrals = () => {
    this.setState({ referrals: [...this.state.referrals, { first_name: "", last_name: "", email: "", phone: "" }] }) // NOSONAR
  }

  removeReferrals = (index) => {
    let filterInfo = this.state.referrals;  // NOSONAR
    filterInfo.splice(index, 1)
    this.setState({ referrals: filterInfo })
  }

  onChangeReferrals = (e, index) => {
    let filterInfo = this.state.referrals;  // NOSONAR
    filterInfo[index] = { ...filterInfo[index], [e.target.name]: e.target.value };
    this.setState({ referrals: filterInfo })
  }

  onMicrosoftBooking = () => {
    // this.setState({microsoft_loading:true,microsoft_modal:true})
    // axios.get(`/api/msbooking/get_service_type_link/${this.state.lsp}?service_type=von_setup_appointment`).then(({data:{service_url,success,error_response}})=>{
    //   if(success && service_url && !error_response){
    //     var w = window.open("about:blank", "_blank");
    //     w.location = service_url
    //   }else{
    //     message.error(error_response)
    //   }
    // }).finally(()=>{
    //   this.setState({microsoft_loading:false})
    // })
  }


  updateMicrosoftAppointment = (e) => {
    this.setState({ microsoft_appointment_date: e })
  }

  render() {
    // console.log("SCHEDULE APPOINTMENT")
    const { users, loading, action, type_of_call, scheduled_via, referrals, sub_type_of_call, microsoft_loading, has_microsoft, has_manual_links, meeting_link } = this.state;
    // F.log("USer s=>", users);
    // F.log("BFILEE", this.state.bfile);
    // F.log("LSP ==>>", this.state.appointment_date);
    /*  
        if (this.state.has_calendly) {
            if (this.state.customer_info && !this.state.email_updated && (!this.state.customer_info.email || this.state.customer_info.email === "")) {
                return (
                    <Modal
                        title={<Translate text={`Update B File`} />}
                        visible={this.props.showModal}
                        onOk={this.saveEmail.bind(this)}
                        onCancel={this.props.hideModal}
                        okText={<Translate text={`Save B File`} />}
                    >
                        <Spin indicator={antIcon} spinning={loading}>
                            <div>
                                <p>Please update customer email first.</p>

                                <div style={{marginBottom:10}}>
                                    <label><Translate text={`Email`} />:</label>
                                    <Input type="text" value={this.state.customer_email} onChange={(e) => this.setState({ customer_email: e.target.value })} />
                                </div>
                            </div>
                        </Spin>
                    </Modal>
                )
            }
        }
        */

    // F.log("timezone==>>", JSON.stringify(this.props.bfile));


    const subType_list = SUB_TYPE_OF_CALL[type_of_call] || [];

    // Object.keys(SUB_TYPE_OF_CALL).forEach(e=>{
    //     sub_type_of_call_list[e.toLowerCase()] = SUB_TYPE_OF_CALL[e]
    // })

    return (
      <Modal
        title={<Translate text={`Setup Appointment`} />}
        visible={this.props.showModal}
        onOk={this.notReachedAndNotInterestedAction.bind(this)}
        onCancel={this.props.hideModal}
        okText={<Translate text={`Save`} />}
        width={'600px'}
        footer={
          // action === "1" && this.state.has_calendly
          action === "1" // "Schedule Follow Up - Case"
            ? [
              <Button key="cancel"
                className="borderRadius-28"
                onClick={this.props.hideModal}>
                Cancel
              </Button>,
              <Button
                key="submit"
                className="btn-bg-164897 borderRadius-28"
                onClick={this.scheduleFollowUpAction.bind(this)}
                loading={this.state.loading}
              >
                Save
              </Button>
            ]
            : [
              <Button key="cancel"
                className="borderRadius-28"
                onClick={this.props.hideModal}>
                Cancel
              </Button>,
              <Button
                key="submit"
                className="btn-bg-164897 borderRadius-28"
                onClick={this.notReachedAndNotInterestedAction.bind(this)}
              // onClick={() => alert(123)}
              >
                Save
              </Button>
            ]
        }
      >
        <Spin indicator={antIcon} spinning={false}>
          <div className="formBox">
            {users.length > 0 ? (
              <div style={{ marginBottom: 10 }}>
                <Select
                  value={this.state.lsp}
                  style={{ width: 300 }}
                  onChange={(val) => {
                    var appointment_hours = null;
                    var calendar_invites = [];
                    var virtual_link = null;
                    var has_calendly = false;
                    var has_microsoft = false;
                    var has_manual_links = false;
                    var scheduled_via = "";
                    for (let i = 0; i < users.length; i++) {
                      if (users[i].id === val) {
                        appointment_hours = users[i].appointment_hours;
                        calendar_invites = users[i].calendar_invites;
                        virtual_link = users[i].virtual_link;
                        has_calendly = users[i].has_calendly;
                        has_microsoft = users[i].has_microsoft;
                        has_manual_links = users[i].has_manual_links;
                        scheduled_via = ""
                        break;
                      }

                    }
                    this.setState({
                      lsp: val,
                      appointment_hours: appointment_hours
                        ? JSON.parse(appointment_hours)
                        : null,
                      calendar_invites: calendar_invites
                        ? calendar_invites
                        : [],
                      virtual_link,
                      has_calendly,
                      has_manual_links,
                      has_microsoft,
                      note: virtual_link ? virtual_link : "",
                      scheduled_via
                    }, () => {
                      this.loadingSchedulingData(this.state.type_of_call)
                    });

                  }}
                >
                  {users.map((user, i) => (
                    <Option key={i} value={user.id}>
                      {user.name} (
                      {user.user_type === "EA"
                        ? "Agency Owner"
                        : user.user_type === "LSP"
                          ? "Agency Sales Staff"
                          : user.user_type}
                      )
                    </Option>
                  ))}
                </Select>
              </div>
            ) : null}
            <div style={{ marginBottom: 10 }}>
              {/* <Radio.Group
                value={this.state.action}
                onChange={(e) => this.setState({ action: e.target.value })}
              >
                <Radio value="1">
                  <Translate text={`Schedule Follow Up`} />
                </Radio> */}
              {/* <Radio value="0">
                  <Translate text={`Not Reached`} />
                </Radio>
                <Radio value="2">
                  <Translate text={`Not Interested`} />
                </Radio> */}
              {/* </Radio.Group> */}
              {/* <Translate text={`Schedule Follow Up`} /> */}
              <Translate text={`Schedule Appointment`} />

            </div>
            <Col md={24} span={24}>
              <div style={{ marginBottom: 10 }}>
                <label>
                  <Translate text={`Type of Call`} />:
                  <span className='asteriskIcon'>*</span>
                </label>
                <Select
                  value={this.state.type_of_call.toLowerCase() === 'followup' && 'FollowUp' || this.state.type_of_call}
                  style={{ width: "100%" }}
                  onChange={(value) => {
                    this.setState({
                      type_of_call: value,
                      sub_type_of_call: value === 'FollowUp' ? 'Thank You / Referrals' : "",
                      scheduled_via: ""
                    });
                    this.loadingSchedulingData(value)
                  }}
                >
                  <Option value={""}>
                    <Translate text={`Select`} />
                    ...
                  </Option>
                  {this.state.roles.includes(FOLLOWUP) && <Option value="FollowUp">
                    <Translate text={`Opportunity`} />
                  </Option>
                  }
                  {this.state.roles.includes(PROSPECT) && <Option value="Prospect">
                    <Translate text={`Lead`} />
                  </Option>
                  }
                </Select>
              </div>
            </Col>
            {action === "1" ? (
              <div>
                <div style={{ marginBottom: 10 }}>
                  <label>
                    {/* <Translate text={`Follow-Up Date`} />: */}
                    <Translate text={`Appointment Date`} />:
                    <span className='asteriskIcon'>*</span>
                  </label>
                  {F.log("this.state.has_clandely", this.state.has_calendly)}
                  {F.log(
                    "this.state.calendly_loading",
                    this.state.calendly_loading
                  )}
                  <Radio.Group

                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                    onChange={this.onChangeScheduledVia}
                    value={this.state.scheduled_via}  >
                    {
                      this.state.externalLinks.map((item, index) => {
                        // console.log(  item.userId,"userID")
                        // console.log( this.state.lsp,"lsp")
                        // console.log(this.state.lsp==item.userId)
                        // if(item.userId===this.state.lsp){
                        //   return item.meetings_list.map((item,index)=>{
                        // console.log("test list itenm",item)
                        return (
                          <Radio value={item.id}
                            key={index}
                            style={{
                              width: "auto",
                              display: "flex",
                              alignItems: "center",
                              height: "15px",
                            }}
                          >
                            <Tooltip placement="top" title={item.meeting_title}>

                              <a
                                style={{
                                  wordBreak: "break-word",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "inline-block",
                                  maxWidth: "500px",
                                  marginTop: "5px",
                                }}
                                href={item.meeting_link} target="_blank"
                                onClick={() => this.setState({ scheduled_via: item.id })}
                              >
                                {item.meeting_title}
                              </a>
                            </Tooltip>
                          </Radio>
                        )
                        // })
                        // }
                      })
                    }
                    <Radio value={"Internal System"}
                      style={{ width: "auto" }}                    >
                      <a>No Link/Internal Calendar </a>
                    </Radio>
                  </Radio.Group>

                  <DatePicker
                    dateFormat="MM/dd/yyyy h:mm aa"
                    showTimeSelect
                    timeIntervals={15}
                    timeFormat="hh:mm aa"
                    shouldCloseOnSelect={false}
                    selected={
                      this.state.appointment_date &&
                        this.state.appointment_date !== ""
                        ? new Date(this.state.appointment_date)
                        : null
                    }
                    onChange={(val) => {
                      const date = moment(val).format(
                        "YYYY-MM-DD HH:mm:ss"
                      );
                      this.setState({ appointment_date: date });
                    }}
                    minDate={F.getFutureDateForAppointment()}
                  />

                  {/* {['Internal System', 'Manual Microsoft Booking'].includes(this.state.scheduled_via) ? (
                    <div>

                      {!this.state.appointment_hours ? (
                        <DatePicker
                          dateFormat="MM/dd/yyyy h:mm aa"
                          showTimeSelect
                          timeIntervals={15}
                          timeFormat="hh:mm aa"
                          shouldCloseOnSelect={false}
                          selected={
                            this.state.appointment_date &&
                              this.state.appointment_date !== ""
                              ? new Date(this.state.appointment_date)
                              : null
                          }
                          onChange={(val) => {
                            const date = moment(val).format(
                              "YYYY-MM-DD HH:mm:ss"
                            );
                            this.setState({ appointment_date: date });
                          }}
                          minDate={F.getFutureDateForAppointment()}
                        />
                      ) : (
                        <div>
                          <div style={{ marginBottom: 10 }}>
                            <DatePicker
                              dateFormat="MM/dd/yyyy h:mm aa"
                              showTimeSelect
                              timeIntervals={15}
                              timeFormat="hh:mm aa"
                              shouldCloseOnSelect={false}
                              selected={
                                this.state.appointment_date &&
                                  this.state.appointment_date !== ""
                                  ? new Date(this.state.appointment_date)
                                  : null
                              }
                              filterDate={(date) => {
                                const day = moment(date).format("dddd");
                                return (
                                  this.state.appointment_hours[day].length > 0
                                );
                              }}
                              filterTime={(date) => {
                                const day = moment(date).format("dddd");
                                const hour = moment(date).format("h:mm a");

                                for (
                                  let i = 0;
                                  i < this.state.calendar_invites.length;
                                  i++
                                ) {
                                  const d = new Date(
                                    this.state.calendar_invites[i]
                                  );
                                  if (
                                    moment(d).format("YYYY-MM-DD HH:mm") ===
                                    moment(date).format("YYYY-MM-DD HH:mm")
                                  ) {
                                    return false;
                                  }
                                }

                                return (
                                  this.state.appointment_hours[day].length >
                                  0 &&
                                  this.state.appointment_hours[day].indexOf(
                                    hour
                                  ) >= 0
                                );
                              }}
                              onChange={(val) => {
                                const date = moment(val).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                );
                                this.setState({
                                  appointment_date: date
                                });
                              }}
                              minDate={F.getFutureDateForAppointment()}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ) : ['Microsoft Booking'].includes(this.state.scheduled_via) &&
                  <Microsoft_apppointment ref={this.microsoft_ref} customer_info={this.state.customer_info} updateMicrosoftAppointment={this.updateMicrosoftAppointment} microsoft_appointment_date={this.state.microsoft_appointment_date} onChangeScheduledVia={this.onChangeScheduledVia} bfile={this.state.bfile} lsp={this.state.lsp} service_type="von_setup_appointment" appointment_date={(date) => this.setState({ appointment_date: date })} />
                  } */}

                  {(this.state.scheduled_via === 'Manual Microsoft Booking' && meeting_link) && (
                    <Row style={{ marginTop: 10 }}><a target="_blank" href={this.state.meeting_link}>Meeting Link</a></Row>
                  )}
                  {/* {this.state.user.user_type === "VONBOARDER" ? */}
                  <div style={{ marginTop: 10 }}>

                    <Translate text={'Do you have any Referrals?'} />
                    <Row gutter={16}>
                      <Col md={19} span={24}>
                        <Radio.Group style={{ display: 'flex' }} onChange={this.onChangeIsReferrals} value={this.state.isReferrals}>
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>

                      {referrals.length > 0 &&
                        <Col md={5} span={24}>
                          <Button onClick={this.addMoreReferrals} size="small"
                            className="borderRadius-28"
                          >+Add more</Button>
                        </Col>
                      }
                    </Row>

                    {referrals.length !== 0 ?

                      referrals.map((e, i) => {
                        return (
                          <Row>
                            <Col md={24} span={24}>
                              <Row gutter={8} style={{ marginTop: 10 }}>
                                <Col md={12} span={24}>
                                  <label>
                                    <Translate text={"First Name"} />
                                    <span className='asteriskIcon'>*</span>
                                  </label>
                                  <Input onChange={(e) => this.onChangeReferrals(e, i)} name="first_name" value={e.first_name} placeholder="First Name" />
                                </Col>
                                <Col md={referrals.length > 1 ? 11 : 12} span={24}>
                                  <label>
                                    <Translate text={"Last Name"} />
                                    <span className='asteriskIcon'>*</span>
                                  </label>
                                  <Input onChange={(e) => this.onChangeReferrals(e, i)} name="last_name" value={e.last_name} placeholder="Last Name" />
                                </Col>

                                {referrals.length > 1 &&
                                  <Col md={1} span={24}>
                                    <Icon onClick={() => this.removeReferrals(i)} style={{ position: 'absolute', top: '35px', cursor: 'pointer' }} type="close-circle" />
                                  </Col>
                                }
                              </Row>
                            </Col>
                            <Col md={24} span={24}>
                              <Row gutter={8} style={{ marginTop: 10 }}>
                                <Col md={12} span={24}>
                                  <label>
                                    <Translate text={"Phone Number"} />
                                    <span className='asteriskIcon'>*</span>
                                  </label>
                                  <Input onChange={(e) => {
                                    if (e.target.value.trim().length <= 14) {
                                      e.target.value = F.phone_format(e.target.value.trim().replace(/[^0-9]/g, ''));
                                      this.onChangeReferrals(e, i)
                                    }

                                  }} name="phone" value={e.phone} placeholder="Phone Number" />
                                </Col>
                                <Col md={referrals.length > 1 ? 11 : 12} span={24}>
                                  <label>
                                    <Translate text={"Email-Id"} />
                                  </label>
                                  <Input type="email" onChange={(e) => this.onChangeReferrals(e, i)} name="email" value={e.email} placeholder="Email-Id" />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        )
                      })

                      : null}
                  </div>
                  {/* null} */}

                </div>
                <div>
                  <div style={{ marginBottom: 10 }}>
                    <label>
                      <Translate text={`Appointment Location`} />:
                      <span className='asteriskIcon'>*</span>
                    </label>
                    <Select
                      value={this.state.type}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        this.setState({ type: value });
                        if (value === "Virtual") {
                          if (this.state.virtual_link) {
                            this.setState({
                              note:
                                "We have scheduled a virtual meeting for you on " +
                                moment(this.state.appointment_date).format( // NOSONAR
                                  "MM/DD/YYYY hh:mmA"
                                ) +
                                ". Please click the link below at your scheduled time:\n" +
                                this.state.virtual_link // NOSONAR
                            });
                          }
                        }
                      }}
                    >
                      <Option value={""}>
                        <Translate text={`Select`} />
                        ...
                      </Option>
                      <Option value="Phone">
                        <Translate text={`Phone`} />
                      </Option>
                      <Option value="Office">
                        <Translate text={`Office`} />
                      </Option>
                      <Option value="Virtual">
                        <Translate text={`Virtual`} />
                      </Option>
                    </Select>
                  </div>
                </div>
                <Row gutter={16}>


                  {type_of_call && <Col md={24} span={24}>
                    <div style={{ marginBottom: 10 }} id="setup_appoinment_vo">
                      <label>
                        <Translate text={`Sub Type of Call`} />:
                        <span className='asteriskIcon'>*</span>
                      </label>
                      {type_of_call && type_of_call.split("-").join("").toLowerCase() === 'followup' && <Checkbox.Group value={get_label_from_value(sub_type_of_call, "value", this.state.type_of_call) && get_label_from_value(sub_type_of_call, 'value', this.state.type_of_call).split(",") || []}
                        onChange={(value) => this.setState({ sub_type_of_call: value.join() || "" })}
                        style={{ display: 'flex', flexWrap: 'wrap' }}
                      //  options={subType_list}   
                      >
                        {subType_list.map((option, i) => (
                          <Checkbox key={i} value={option.value} style={{ width: 180 }} disabled={option.disable}>
                            {option.label}
                          </Checkbox>))}

                      </Checkbox.Group>
                      }
                      {type_of_call && ['prospect', 'review'].includes(type_of_call.toLowerCase()) &&
                        <Radio.Group style={{ width: '100%' }} value={get_label_from_value(sub_type_of_call, 'value', this.state.type_of_call)} name='sub_type_of_call' onChange={(e) => this.setState({ sub_type_of_call: e.target.value })}  >
                          <Row gutter={12}>
                            {subType_list.map((e, i) => {
                              return (
                                <Col md={9} span={24}>
                                  <Radio value={e.value}>{e.label}</Radio>
                                </Col>
                              )
                            })}
                          </Row>
                        </Radio.Group>
                      }
                      {/* <Select
                      value={this.state.sub_type_of_call}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        this.setState({ sub_type_of_call: value });
                      }}
                    >
                      <Option value={""}>
                        <Translate text={`Select`} />
                        ...
                      </Option>
                      {sub_type_of_call_list[type_of_call.toLowerCase()] && sub_type_of_call_list[type_of_call.toLowerCase()].map(e=>{
                        return(
                      <Option value={e}>
                        <Translate text={e} />
                      </Option>
                        )
                      })}
                     </Select> */}
                    </div>
                  </Col>}
                </Row>
                {this.state.scheduled_via !== 'Calendly' ? (
                  <div>
                    <div style={{ marginBottom: 10 }}>
                      <label>
                        <Translate text={`Timezone`} />:
                        <span className='asteriskIcon'>*</span>
                      </label>
                      <Select
                        value={this.state.timezone}
                        style={{ width: "100%" }}
                        onChange={(value) => this.setState({ timezone: value })}
                      >
                        <Option value={""}>
                          <Translate text={`Select Timezone`} />
                          ...
                        </Option>
                        <Option value="US/Samoa">
                          <Translate text={`Samoa Time Zone`} /> (-11:00)
                        </Option>
                        <Option value="US/Hawaii">
                          <Translate text={`Hawaii-Aleutian Time Zone`} />{" "}
                          (-10:00)
                        </Option>
                        <Option value="US/Alaska">
                          <Translate text={`Alaska Time Zone`} /> (-09:00)
                        </Option>
                        <Option value="US/Pacific">
                          <Translate text={`Pacific Time Zone`} /> (-08:00)
                        </Option>
                        <Option value="US/Mountain">
                          <Translate text={`Mountain Time Zone`} /> (-07:00)
                        </Option>
                        <Option value="US/Central">
                          <Translate text={`Central Time Zone`} /> (-06:00)
                        </Option>
                        <Option value="US/Eastern">
                          <Translate text={`Eastern Time Zone`} /> (-05:00)
                        </Option>
                      </Select>
                    </div>
                    <div style={{ marginBottom: 10 }}>
                      <label>
                        <Translate text={`Invitee Email`} />:
                      </label>
                      <Input
                        type="text"
                        value={this.state.invitee_email}
                        onChange={(e) =>
                          this.setState({
                            invitee_email: e.target.value
                          })
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    {this.state.has_calendly && this.state.scheduled_via === 'Calendly' && <p>
                      Please add the customer email in Calendly event guest
                      list.
                    </p>}
                    <div style={{ marginBottom: 10 }}>
                      <label>
                        <Translate text={`Name`} />:
                      </label>
                      <Row gutter={16}>
                        <Col md={12} span={24}>
                          <Input
                            type="text"
                            defaultValue={this.state.customer_info.first_name}
                            onChange={(e) =>
                              this.updateField("first_name", e.target.value)
                            }
                            maxLength={50}
                          />
                        </Col>
                        <Col md={12} span={24}>
                          <Input
                            type="text"
                            defaultValue={this.state.customer_info.last_name}
                            onChange={(e) =>
                              this.updateField("last_name", e.target.value)
                            }
                            maxLength={50}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div style={{ marginBottom: 10 }}>
                      <label>
                        <Translate text={`Phone`} />:
                      </label>
                      <Input
                        type="text"
                        value={F.phone_format(this.state.customer_info.phone)}
                        onChange={(e) => {
                          if (e.target.value.trim().length <= 14) {
                            const updateNumber = F.phone_format(e.target.value);
                            this.updateField("phone", updateNumber);
                          }
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: 10 }}>
                      <label>
                        <Translate text={`Email`} />:
                      </label>
                      <Input
                        type="text"
                        defaultValue={this.state.customer_info.email}
                        onChange={(e) =>
                          this.updateField("email", e.target.value)
                        }
                      />
                    </div>
                  </div>
                )}

              </div>
            ) : null}

            <div>
              <label>
                <Translate text={`Note`} />:
                <span className='asteriskIcon'>*</span>
              </label>
              <TextArea
                rows={4}
                value={this.state.note}
                onChange={(e) => this.setState({ note: e.target.value })}
              />
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }
}

export default withRouter(DashModal);



// WEBPACK FOOTER //
// src/scenes/LandingPage/parts/setup-appointment-modal-vo.js


// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/setup-appointment-modal-vo.js